package one.healthium.domain.common


import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CtaConfig(
    @SerialName("height") val height: Int,
    @SerialName("style") val style: String,
    @SerialName("animation_key") val animationKey: String,
    @SerialName("background_color") @Contextual val backgroundColor: Color,
)